module.exports = __webpack_public_path__ + "img/dryer-heat.7f05c43e.svg";